import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiErrorMessage } from "../lib/api";

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace("#", "?"));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    exchangeGoogleSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user } });
      })
      .catch((err) => {
        window.history.replaceState(null, "", "/login");
        setError(apiErrorMessage(err.response?.data?.detail) || "Connexion refusée.");
      });
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-[#0A0D12] flex items-center justify-center px-4">
        <div className="max-w-sm text-center space-y-4">
          <div data-testid="google-auth-error" className="text-sm text-red-400 bg-red-950/40 border border-red-900 rounded-lg px-4 py-3">
            {error}
          </div>
          <button
            data-testid="google-auth-retry-button"
            onClick={() => navigate("/login", { replace: true })}
            className="text-cyan-400 text-xs font-mono uppercase tracking-widest underline"
          >
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0D12] flex items-center justify-center" data-testid="google-auth-loading">
      <Loader2 className="w-8 h-8 text-cyan-400 animate-spin" />
    </div>
  );
}
